import React, {memo, useLayoutEffect} from "react";
import {Badge, Button, Col, Row} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {handelOpenModalSelectBaseMarket} from "../../../../redux/actions/modals/modalSelectBaseMarket";
import {handelOpenModalLoginAndRegister} from "../../../../redux/actions/modals/modalLoginAndRegister";
import {useHistory, useRouteMatch} from "react-router-dom";
import {handelOpenModalShoppingCard} from "../../../../redux/actions/modals/modalShoppingCard";
import {handelOpenModalEditProfile} from "../../../../redux/actions/modals/modalEditProfile";
import {FaAngleDown, FaHome, FaShoppingCart} from "react-icons/all";

import {actionRefreshModalShoppingCard} from "../../../../redux/actions/modals/modalShoppingCard";

const HeaderWithShopping = (props) => {
    const match = useRouteMatch();
    const dispatch = useDispatch();
    const {token, profile} = useSelector(state => state.user);
    const {carts} = useSelector(state => state.shoppingCart);
    const store = useSelector(state => state.stores.list_stores.find(storeItem => storeItem.id === match.params.store));
    const {fullname} = profile;
    let history = useHistory();
    const refNavigation = React.createRef();


    const openModalChangeShopping = () => {
        // if (token) {
        //     /*API GET STORES*/
        //     dispatch(handelOpenModalSelectBaseMarket('header-shopping'));
        // } else
        //     dispatch(handelOpenModalLoginAndRegister());
        dispatch(handelOpenModalSelectBaseMarket('header-shopping'));
    };

    const goToPageStores = () => {
        if(localStorage.getItem("editOrderMode") !== undefined && localStorage.getItem("editOrderMode") !== null) {
            localStorage.removeItem("editOrderMode");
            dispatch(actionRefreshModalShoppingCard());
        }
        history.push('/stores');
    }

    const openModalShoppingCard = () => {
        // if (token) {
        //     dispatch(handelOpenModalShoppingCard());
        // } else {
        //     dispatch(handelOpenModalLoginAndRegister());
        // }
        dispatch(handelOpenModalShoppingCard());
    };

    useLayoutEffect(() => {
        const NAVIGATION = refNavigation.current;
        const onScroll = () => {
            let scrollNumber = document.documentElement.scrollTop;
            if (scrollNumber < 30) {
                NAVIGATION.setAttribute("class", "");
            } else if (scrollNumber < 60) {
                if (NAVIGATION.classList.value !== 'base-scroll-bg-station scroll-bg-first-station') {
                    NAVIGATION.setAttribute("class", "");
                    NAVIGATION.classList.add('base-scroll-bg-station', 'scroll-bg-first-station');
                }
            } else if (scrollNumber < 90) {
                if (NAVIGATION.classList.value !== 'base-scroll-bg-station scroll-bg-second-station') {
                    NAVIGATION.setAttribute("class", "");
                    NAVIGATION.classList.add('base-scroll-bg-station', 'scroll-bg-second-station');
                }
            } else if (scrollNumber < 120) {
                if (NAVIGATION.classList.value !== 'base-scroll-bg-station scroll-bg-third-station') {
                    NAVIGATION.setAttribute("class", "");
                    NAVIGATION.classList.add('base-scroll-bg-station', 'scroll-bg-third-station');
                }
            } else if (scrollNumber >= 120) {
                if (NAVIGATION.classList.value !== 'base-scroll-bg-station scroll-bg-fourth-station') {
                    NAVIGATION.setAttribute("class", "");
                    NAVIGATION.classList.add('base-scroll-bg-station', 'scroll-bg-fourth-station');
                }
            }

        };
        if (!!NAVIGATION) {
            window.addEventListener("scroll", onScroll);
        }
        // return () => window.removeEventListener("scroll", onScroll);
    });

    const openModalLoginAndRegister = () => {
        dispatch(!token ? handelOpenModalLoginAndRegister() : handelOpenModalEditProfile());
    };

    const handleCancelEditOrder = () => {
        localStorage.removeItem("editOrderMode");
        dispatch(actionRefreshModalShoppingCard());
        history.push('/stores');
    };


    return (
        <React.Fragment>
        
            <div id={'box-flex-navigation-fixed'} ref={refNavigation}>

                {localStorage.getItem("editOrderMode") !== undefined && localStorage.getItem("editOrderMode") !== null ?
                <div className="header-edit-order-war d-flex justify-content-center" style={{backgroundColor: "yellow", padding: "5px"}}>
                    <span className=" py-1">شما در حال ویرایش سفارش {localStorage.getItem("editOrderMode")} هستید</span>
                    <span className="font-weight-bold mx-2 p-1" 
                        onClick={handleCancelEditOrder}
                        style={{border: "1px solid black", borderRadius: "5px", cursor: "pointer"}}>
                        لغو ویرایش
                    </span>
                </div>
                :''}


                <Row>
                    <Col>
                        <div className={'text-left base-box-icons-header-fixed base-box-right-icons-header-fixed'}>
                            <div className={'first-icon-box-right-icons-header-fixed'}>
                                {carts.length > 0 ?
                                    <Badge pill variant="danger" id={'badge-numbers-basket-shopping-header'}
                                           className={'float-right'}
                                           onClick={openModalShoppingCard}>{carts.length}</Badge>
                                    : ''}
                                <FaShoppingCart className={'ml-2 base-icons-header-fixed'}
                                                onClick={openModalShoppingCard}/>
                            </div>
                        </div>
                    </Col>
                    {localStorage.getItem("editOrderMode") === undefined || localStorage.getItem("editOrderMode") === null ?
                    <Col xs={6} md={4}>
                        <div className={'text-center base-box-select-shopping-fixed'}>
                            <div onClick={openModalChangeShopping}>
                                <div className={'ml-2'}>
                                    <div className={'mr-2'}>انتخاب فروشگاه</div>
                                    {store && <div>{store.title}</div>}
                                </div>
                                <FaAngleDown id={'icon-arrow-box-select-shopping-head'}/>
                            </div>
                        </div>
                    </Col>
                    :''}
                    <Col>
                        <div className={'text-right base-box-icons-header-fixed base-box-left-icons-header-fixed'}>
                            <FaHome className={'base-icons-header-fixed'}
                                    onClick={goToPageStores}/>
                            <Button id={'btn-login-and-register-navigation'} onClick={openModalLoginAndRegister}>
                                {!token ? <span>ورود / ثبت نام</span> :
                                    <span>{fullname !== '' ? fullname : 'نام و نام خانوادگی'}</span>}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    );
};

export default memo(HeaderWithShopping);
